import { REGISTER_PM_TRACKING_SUCCESS } from '.';

export function registerPmTrackingSuccess(event: string) {
  return { event, type: REGISTER_PM_TRACKING_SUCCESS };
}
